import styled from 'styled-components';

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: 24px;
  color: #854ee0;
  margin: 0;
  white-space: nowrap;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background-color: #854ee0;
  width: 100%;
`;
